export const cookies = {
  is: {
    notice: "Við notum vafrakökur til að bæta upplifun þína á vefsíðunni.",
    learnMore: "Lesa meira um vafrakökur",
    accept: "Samþykkja",
    title: "Vafrakökustefna",
    description: "Kynntu þér hvernig við notum vafrakökur á vefsíðunni okkar"
  },
  en: {
    notice: "We use cookies to improve your experience on our website.",
    learnMore: "Learn more about cookies",
    accept: "Accept",
    title: "Cookie Policy",
    description: "Learn about how we use cookies on our website"
  },
  es: {
    notice: "Utilizamos cookies para mejorar tu experiencia en nuestro sitio web.",
    learnMore: "Más información sobre cookies",
    accept: "Aceptar",
    title: "Política de Cookies",
    description: "Aprende cómo utilizamos las cookies en nuestro sitio web"
  },
  da: {
    notice: "Vi bruger cookies til at forbedre din oplevelse på vores hjemmeside.",
    learnMore: "Læs mere om cookies",
    accept: "Accepter",
    title: "Cookie Politik",
    description: "Lær om hvordan vi bruger cookies på vores hjemmeside"
  }
};